<div class="wrapper ">
    <div class="row">
		<div class="col-sm-12">
			<cv-input
				(controlKeyup)="callCenterClient.xpanseClientId = $event.value.trim()"
				[value]="callCenterClient.xpanseClientId"
				[label]="'Xpanse Client Id'"
				[type]="'text'"
				[name]="'name'"
				[minlength]="1"
				[required]="true"
			>
			</cv-input>
		</div>
	</div>
    <div class="row">
		<div class="col-sm-12 cv-input">
			<cv-multiselect-search
				[required]="false"
				[label]="'Default Acuity Branch Name'"
				[placeholder]="'Select a Branch'"
				[options]="acuityLenderBranchesList"
				[values]="acuityBranchSelected"
				[optionText]="'title'"
		        [optionValue]="'id'"
				[singleSelectMode]="true"
				[required]="true"
				(valuesChange)="onBranchSelected($event, 'acuityBranch')"
		        [getOptionsFunction]="lenderService.getAcuityLenderBranches"
			>
			</cv-multiselect-search>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12 cv-input">
			<cv-multiselect-search
				[required]="false"
				[label]="'Default Cmp Acuity Branch Name'"
				[placeholder]="'Select a Branch'"
				[options]="cmpAcuityLenderBranchesList"
				[values]="cmpAcuityBranchSelected"
				[optionText]="'title'"
				[optionValue]="'id'"
				[singleSelectMode]="true"
				[required]="true"
				(valuesChange)="onBranchSelected($event, 'cmpacuity')"
				[getOptionsFunction]="lenderService.getCmpAcuityLenderBranches"
			>
			</cv-multiselect-search>
		</div>
	</div>
    <div class="row">
		<div class="col-sm-12 cv-input">
			<cv-multiselect-search
				[required]="false"
				[label]="'Default AppScope Client Name'"
				[placeholder]="'Select a AppScope client'"
				[options]="appScopeLendersList"
				[values]="clientBranchSelected"
				[optionText]="'title'"
		        [optionValue]="'id'"
				[singleSelectMode]="true"
				[required]="true"
				(valuesChange)="onBranchSelected($event, 'appscopeClient')"
		        [getOptionsFunction]="lenderService.getLenders"
			>
			</cv-multiselect-search>
		</div>
	</div>
    <div class="row">
		<div class="col-sm-12">
			<cv-input
				(controlKeyup)="callCenterClient.defaultAppScopeUserCreation = $event.value.trim()"
				[value]="callCenterClient.defaultAppScopeUserCreation"
				[label]="'AppScope Integration User'"
				[type]="'text'"
				[name]="'name'"
				[minlength]="1"
				[required]="true"
			>
			</cv-input>
		</div>
	</div>
</div>
